import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewEncapsulation } from '@angular/core';
import { UserRelationshipGroup, Relationship, RelationshipDataGroup } from '../../models/UserRelationship';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ConfirmationService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { UserRelationshipService } from '../../user-relationship.service';
import { PersonService } from '../../../person/person.service';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss'],
  providers: [ConfirmationService],
  encapsulation: ViewEncapsulation.None
})
export class EditUserComponent implements OnInit, OnDestroy {

  @Input() displayDialog: boolean;
  @Input() userRelationship: UserRelationshipGroup;
  @Input() RelationshipWithContact: [];

  @Output() onDialogClose = new EventEmitter<boolean>();
  @Output() onEditUser = new EventEmitter<UserRelationshipGroup[]>();
  @Output() onMessage = new EventEmitter<any>();

  processing = false;
  subscription: Subscription;
  relationship: Relationship[];
  relationshipSelected: Relationship[];
  relationshipDataGroup: RelationshipDataGroup[];
  manageUserRelationshipId: number[] = [];
  userRelationshipGroup: any;
  displayLoginstatus: boolean;
  displayItems: any[];
  relationshipAndContactId: any[];
  displayNewContactList = false;
  isPrimaryContactSelected = true;
  isPrimaryContact = false;
  showResetPasswordLink:boolean=true;
  enableResetCancelButtons : boolean=false;
  emailStatus:boolean=false;

  public editUserForm: FormGroup = new FormGroup({
    PersonDetail: new FormGroup({
      PersonId: new FormControl('', [Validators.required]),
      Email: new FormControl('', [Validators.required]),
      loginEnabled: new FormControl(''),
      IsActive: new FormControl('')
    })
  });

  personGroup = this.editUserForm.get('PersonDetail');
  email = this.personGroup.get('Email');
  loginStatus = this.personGroup.get('loginEnabled');
  personId =  this.personGroup.get('PersonId');
  personStatus = this.personGroup.get('IsActive');
  passwordEmailSent: any;
  loading: boolean;

  constructor(private confirmationService: ConfirmationService,
       private userRelationshipSvc: UserRelationshipService
       , private personSvc: PersonService) { }

  ngOnInit() {
    this.personId.setValue(this.userRelationship.PersonDetail.PersonId);
    this.email.setValue(this.userRelationship.PersonDetail.Email);
    this.loginStatus.setValue(!this.userRelationship.PersonDetail.IsLocked);
    this.personStatus.setValue(this.userRelationship.PersonDetail.IsActive);
    this.initData();
    this.displayLoginstatus = this.userRelationship.PersonDetail.IsLocked;
    this.personStatus.valueChanges.subscribe(val => {
      this.userStatusChange(val);
    });
  }

  showResetCancelButtons(): void {
    this.enableResetCancelButtons = true;
    this.showResetPasswordLink = false;
  }

  hideResetCancelButtons(): void {
    this.enableResetCancelButtons = false;
    this.showResetPasswordLink = true;
  }

  emailResetPasswordLink(): void {
    this.emailStatus = false;
    this.enableResetCancelButtons = false;
    this.showResetPasswordLink = false;
    this.loading = true;
    this.personSvc.sendEmail(this.userRelationship.PersonDetail.PersonId, true)
      .subscribe((res: any) => {
        this.onMessage.emit({ severity: 'success', summary: 'Password Email Sent' });
        this.emailStatus = res.data[0].passwordEmailSent;
        this.loading = false;
      }, error => {
        this.onMessage.emit({ severity: 'error', summary: 'Error Occcured while Processing' });
        this.loading = false;
      });
  }

  showResetPasswordSection(user) : boolean  {
    return user.PersonDetail.hasOwnProperty('IsPreReg') && !user.PersonDetail.IsPreReg && user.PersonDetail.IsActive ? true : false;
  }

  initData(): void {
    this.relationship = [];
    this.relationshipDataGroup = [];
    for (let i = 0, aRelation = this.userRelationship.Relationship; i < aRelation.length; i++) {
      if (!this.isPrimaryContact) {
        this.isPrimaryContact = aRelation[i].IsPrimaryContact;
      }
      this.relationship.push({Id: aRelation[i].Id, Company: aRelation[i].Company});
      if (aRelation[i].CanAddUser) {
        this.manageUserRelationshipId.push(aRelation[i].Id);
      }
      for (let j = 0, aGroup = aRelation[i].RelationshipDataGroup ; j < aGroup.length; j++) {
        this.relationshipDataGroup.push(aGroup[j]);
      }
    }
  }

  dialogClose() {
    this.onDialogClose.emit(false);
  }

  assetGroupChange(relationshipDataGroup: RelationshipDataGroup[]): void {
    this.relationshipDataGroup = relationshipDataGroup;
  }

  canAddUserChange() {}

  processFormdata(): void {
    this.userRelationshipGroup = _.cloneDeep(this.editUserForm.value);
    this.userRelationshipGroup.Relationship = this.userRelationship.Relationship;
    /* Add NewPrimaryContactId to the Relationship block */
    if (typeof this.relationshipAndContactId !== 'undefined' && this.relationshipAndContactId.length > 0) {
      this.userRelationshipGroup.Relationship.map( (relationship) => {
        let newPrimaryContactId = '';
        for (let i = 0; i < this.relationshipAndContactId.length; i++) {
          if (relationship.Id === this.relationshipAndContactId[i].RelationshipId) {
            newPrimaryContactId = this.relationshipAndContactId[i].NewPrimaryContactId;
            break;
          }
        }
        relationship.NewPrimaryContactId = newPrimaryContactId;
        return relationship;
      });
    }
  }

  mapRelationshipAndContactId(relationshipAndContactId: []): void {
    this.relationshipAndContactId = relationshipAndContactId;
  }

  checkIsPrimaryContactReady(isPrimaryContactReady: boolean): void {
    this.isPrimaryContactSelected = typeof isPrimaryContactReady === 'undefined' ? true : isPrimaryContactReady;
  }

  changePrimaryContact(e): void {
    if (e.checked) {
      this.displayNewContactList = false;
      this.isPrimaryContactSelected = true;
    }
  }

  onSubmit() {
    if (this.editUserForm.valid) {
      this.processing = true;
      this.processFormdata();
      this.subscription = this.userRelationshipSvc.update([this.userRelationshipGroup])
        .subscribe((user: any) => {
          this.onEditUser.emit(user.data);
          this.processing = false;
          this.displayDialog = false;
      }, error => {
        this.processing = false;
        this.displayDialog = false;
        this.onMessage.emit({severity: 'error', summary: 'Error Occcured while Processing'});
      });
    }
  }

  userStatusChange(flag: boolean): void {
    if (!flag) {
      const message = `Are you sure you want to Inactivate Partner User:
      ${this.userRelationship.PersonDetail.FirstName}
      remove their access from all Partnerships and Asset Groups?`;
      this.confirmationService.confirm({
          message: message,
          accept: () => {
            if (this.isPrimaryContact) {
              this.displayNewContactList = true;
              this.isPrimaryContactSelected = false;
            }
          },
          reject: () => {
            this.personStatus.setValue(!flag);
            this.displayNewContactList = false;
            this.isPrimaryContactSelected = true;
          }
      });
    }
  }

  resendEmail() {
    this.confirmationService.confirm({
      message: 'Are you sure you want Reset/Resend Initial Email ?',
      reject: () => {
      },
      accept: () => {
        this.sendMessage();
      }
    });
  }

  sendMessage() {
    this.subscription = this.personSvc.sendEmail(this.userRelationship.PersonDetail.PersonId)
        .subscribe((res: any) => {
          this.onMessage.emit({severity: 'success', summary: 'Email Sent'});
          this.processing = false;
          this.displayDialog = false;
      }, error => {
        this.onMessage.emit({severity: 'error', summary: 'Error Occcured while Processing'});
        this.processing = false;
        this.displayDialog = false;
    });
  }

  displaySelectedItems(op, event, displayItem): void {
    this.displayItems = [];
    if (displayItem === 'Relationship') {
      this.displayItems = this.relationshipSelected.map(items => items.RelationshipName);
    } else if (displayItem === 'RelationshipDataGroup') {
      for (let i = 0, aRelation = this.relationshipSelected; i < aRelation.length; i++) {
        for (let j = 0, aGroup = this.relationshipDataGroup; j < aGroup.length; j++) {
          if (aRelation[i].Id === aGroup[j].RelationshipId && this.displayItems.indexOf(aRelation[i]) === -1) {
            this.displayItems.push(aRelation[i]);
          }
        }
      }
    }
    op.show(event);
  }

  assetGroupByRelationhipId(id) {
    return this.relationshipDataGroup.filter((group) => group.RelationshipId === id);
  }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }
}
